var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDone(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 10,
    viewBox: "0 0 12 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.1931 0.502202C10.9503 0.484804 10.7016 0.570511 10.5163 0.759324L3.80075 7.60078L1.48369 5.24028C1.14429 4.89451 0.592554 4.89451 0.253151 5.24028C0.081495 5.41515 -0.00286401 5.64493 7.41684e-05 5.87376C-0.00150522 5.9893 0.0221403 6.10513 0.0710106 6.21182C0.113054 6.31066 0.173768 6.40327 0.253151 6.48414L3.18548 9.47144C3.19325 9.47936 3.20113 9.48709 3.20912 9.49464L3.21967 9.50547C3.37232 9.66203 3.57441 9.737 3.7744 9.73036C4.00588 9.73745 4.23963 9.65114 4.41602 9.47144L11.7468 2.00319C11.9301 1.81653 12.0138 1.56733 11.9981 1.32349C12.0128 1.10896 11.9402 0.889313 11.7803 0.725302C11.6194 0.560253 11.4035 0.485886 11.1931 0.502202Z",
    fill: "#0063FB"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDone);
export default __webpack_public_path__ + "static/media/done.c965cd9758d4a67c55342fd81eb6a511.svg";
export { ForwardRef as ReactComponent };